import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { DEFAULTS } from 'constants/defaults.constant';

import SocialsBar from 'components/socials/SocialsBar';

const SocialMediaAndLinks = () => {
  const { t } = useTranslation();

  const linkClassName =
    'tw-text-center tw-text-sm tw-font-medium tw-leading-none tw-text-blue-500 tw-transition-colors tw-duration-300 hover:tw-text-blue-400';

  return (
    <div className="tw-mx-auto tw-flex tw-h-[153.5px] tw-w-[264px] tw-flex-col tw-items-start tw-justify-start tw-gap-7">
      {/* Social section */}
      <div className="tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-start tw-gap-3">
        <div className="tw-w-full tw-text-center tw-text-base tw-font-semibold tw-uppercase tw-leading-none tw-text-white">
          follow us on
        </div>
        <SocialsBar
          order={[
            { type: 'discord', icon: 'border' },
            { type: 'instagram', icon: 'border' },
            { type: 'youtube', icon: 'border' },
            { type: 'facebook', icon: 'border' },
            { type: 'twitter', icon: 'border' },
          ]}
          className="list-reset tw-inline-flex tw-items-start tw-justify-start tw-gap-5"
          iconClassName="tw-block tw-h-[31.5px] tw-w-[30px] [&>svg]:tw-h-full [&>svg]:tw-w-full"
        />
      </div>

      {/* Footer section */}
      <div className="tw-flex tw-w-full tw-flex-col tw-items-start tw-justify-center tw-gap-2.5">
        <div className="tw-w-full tw-text-center tw-text-sm tw-font-medium tw-leading-none tw-text-white">
          {t('copyright', { year: new Date().getFullYear() })}
        </div>
        <div className="tw-inline-flex tw-w-full tw-flex-wrap tw-content-center tw-items-center tw-justify-center tw-gap-5">
          <Link className={linkClassName} to={DEFAULTS.privacyPolicyLink} target="_blank">
            Privacy Policy
          </Link>
          <Link className={linkClassName} to={DEFAULTS.termsOfServiceLink} target="_blank">
            Terms of Service
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SocialMediaAndLinks;
